import { render, staticRenderFns } from "./pausePage.vue?vue&type=template&id=227ce10c&"
import script from "./pausePage.vue?vue&type=script&lang=js&"
export * from "./pausePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports